module.exports = __webpack_public_path__ + "img/hopways.84cf8c4d.jpeg";